import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';

import { PermissionsService } from '../shared/services/permissions.service';
import { RouteUtil } from '../shared/utilities/route.util';
import { UserPermissions } from '../shared/models/user-permissions.model';

@Injectable()
export class WorkforceRouteGuardService implements CanActivate, CanLoad {
    userPermissions: UserPermissions;

	constructor(private _router: Router, private _permissionsService: PermissionsService) { 
        this.userPermissions = this._permissionsService.getUserPermissions();
    }

	canLoad(route: Route): boolean {
        return this.checkUserAccess(route.path);
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.checkUserAccess(state.url);
	}

	private checkUserAccess(path: string): boolean {
        let endOfPath = path.indexOf('?');
        if (endOfPath !== -1) {
            path = path.substring(0, endOfPath);
        }
        
        let page = RouteUtil.getPageByRoute(path);
        let hasAccess = RouteUtil.isPageViewable(this.userPermissions, page);

        if (!hasAccess) {
            this._router.navigateByUrl('unauthorized');
        }
        
        return hasAccess;
    }     
}